export default __webpack_public_path__ + "static/media/480_private03-en-mobile.5e52de61.png";